var pluginMap = {};
export function addComposePlugins(viewState, plugins) {
    pluginMap[viewState.composeId] = plugins;
}
export function findComposePlugins(viewState) {
    return pluginMap[viewState.composeId];
}
export function removeComposePlugins(viewState) {
    var plugins = findComposePlugins(viewState);
    if (plugins && plugins.contentOperationPlugin) {
        // We are removing all the plugins, stop auto save since we don't need that now.
        plugins.contentOperationPlugin.stopSaveOnDispose();
    }
    delete pluginMap[viewState.composeId];
}
export function getPluginArray(composePlugins) {
    var plugins = [
        composePlugins.dockingPlugin,
        composePlugins.ribbonPlugin,
        composePlugins.inlineImagePlugin,
        composePlugins.inlineImageResizePlugin,
        composePlugins.emojiPlugin,
        composePlugins.contentOperationPlugin,
        composePlugins.tableEdit,
    ];
    if (composePlugins.smartSuggestionsPlugin) {
        plugins.push(composePlugins.smartSuggestionsPlugin);
    }
    if (composePlugins.linkPreviewPlugin) {
        plugins.push(composePlugins.linkPreviewPlugin);
    }
    if (composePlugins.atMentionsPlugin) {
        plugins.push(composePlugins.atMentionsPlugin);
    }
    if (composePlugins.addinPlugin) {
        plugins.push(composePlugins.addinPlugin);
    }
    if (composePlugins.accCheckerPlugin) {
        plugins.push(composePlugins.accCheckerPlugin);
    }
    if (composePlugins.pasteOptionPlugin) {
        plugins.push(composePlugins.pasteOptionPlugin);
    }
    if (composePlugins.attachmentPlugin) {
        plugins.push(composePlugins.attachmentPlugin);
    }
    if (composePlugins.editorPickerPlugin) {
        plugins.push(composePlugins.editorPickerPlugin);
    }
    return plugins;
}
//# sourceMappingURL=ComposePlugins.js.map